import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const BrandMark: React.FC = () => (
  <span className="brand-mark" aria-hidden="true">
    <i />
    <b />
  </span>
);

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" className="header-logo" aria-label="Observer Theory home">
          <BrandMark />
          <span className="logo-name">Observer Theory</span>
        </Link>

        <nav
          className={`header-nav${open ? " open" : ""}`}
          aria-label="Primary navigation"
        >
          <NavLink to="/practitioners">Browse practitioners</NavLink>
          <NavLink to="/search">Search practitioners</NavLink>
          <NavLink to="/write-review">Write a review</NavLink>
          <NavLink to="/report">Report a problem</NavLink>
          <NavLink to="/trust">Trust centre</NavLink>
          <div className="mobile-nav-divider" />
          <NavLink className="nav-sign-in" to="/sign-in">
            Sign in
          </NavLink>
          <NavLink className="nav-claim" to="/nominate">
            Nominate a practitioner
          </NavLink>
        </nav>

        <div className="desktop-actions">
          <Link className="nav-sign-in" to="/sign-in">
            Sign in
          </Link>
          <Link className="nav-claim" to="/nominate">
            Nominate a practitioner
          </Link>
        </div>

        <button
          className={`menu-toggle${open ? " open" : ""}`}
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Header;
